import { render, staticRenderFns } from "./Change-Lesson.vue?vue&type=template&id=24a62da0&scoped=true"
import script from "./Change-Lesson.vue?vue&type=script&lang=js"
export * from "./Change-Lesson.vue?vue&type=script&lang=js"
import style0 from "./Change-Lesson.vue?vue&type=style&index=0&id=24a62da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a62da0",
  null
  
)

export default component.exports